/** 管理后台接口。 */
import { http } from '@/utils/request'
import type { AdminStats, DashboardStats } from '@/types/admin'
import type { User, ChangePasswordPayload } from '@/types/user'
import type { ApiMessage } from '@/types/common'

export function getDashboard(): Promise<DashboardStats> {
  return http.get<DashboardStats>('/admin/dashboard')
}

export function getUsers(): Promise<User[]> {
  return http.get<User[]>('/admin/users')
}

export function getAdminStats(): Promise<AdminStats> {
  return http.get<AdminStats>('/admin/stats')
}

export function changePassword(payload: ChangePasswordPayload): Promise<ApiMessage> {
  return http.post<ApiMessage>('/admin/change-password', payload)
}
